import { render, staticRenderFns } from "./MemberProject.vue?vue&type=template&id=cb55fd9a&scoped=true"
import script from "./MemberProject.vue?vue&type=script&lang=js"
export * from "./MemberProject.vue?vue&type=script&lang=js"
import style0 from "./MemberProject.vue?vue&type=style&index=0&id=cb55fd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb55fd9a",
  null
  
)

export default component.exports